import axios from "axios";
import { useApi } from "../hooks/useApi"
import { residentWhoLikedProps } from "../../pages/whoEnjoyedTrocsPage/WhoEnjoyedTrocsPage";

const api = useApi();

export async function getResWhoLiked( trocIdTrav: string | undefined): Promise<residentWhoLikedProps[]> {
  try {
    const response = await api.get(`res-liked-troc-trav/list-res/${trocIdTrav}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        console.info(`Requête annulée : ${error.message}`);
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}